export default {
    evaluation: {
        complete: '',
        incomplete: 'Evaluate now'
    },

    set: 'All macro trends rated|Rate {cnt} macro trend|Rate {cnt} macro trends',

    title: 'Macro trends',
    subtitle: 'All trends at a glance. Start the rating by clicking on the macro trend'
}
